import { api, type Job } from "../../../lib/api";
import { currentBuildStatus } from "../../builds/buildProgress";
import { buildFailure } from "../../builds/buildFailure";

export async function waitForAppliedBuild(jobId: string, onProgress?: (status: Job["status"] | "reconnecting") => void): Promise<"ready" | "ready_unverified"> {
  for (let attempt = 0; attempt < 300; attempt++) {
    let job: Job;
    try { ({ job } = await api.getJob(jobId)); }
    catch {
      onProgress?.("reconnecting");
      await new Promise((resolve) => window.setTimeout(resolve, 1_000));
      continue;
    }
    const status = currentBuildStatus(job) ?? job.status;
    onProgress?.(status);
    if (status === "ready" || status === "ready_unverified") return status;
    if (["failed", "runner_start_failed", "timeout", "cancelled"].includes(status)) {
      throw new Error(status === "cancelled" ? "This preview build was cancelled. Your saved changes and existing site are still available." : buildFailure(job, []).title);
    }
    await new Promise((resolve) => window.setTimeout(resolve, 1_000));
  }
  throw new Error("Your changes are saved and this preview build is still being checked. Return to the build status to reconnect; your existing site stays available.");
}
